






























import Vue from 'vue';

import NavigationTile from '@/components/NavigationTile.vue';

export default Vue.extend({
    name: 'home',
    components: {
        'navigation-tile': NavigationTile,
    },
    methods: {
        openAddresses() {
            this.$root.$router.push({
                name: 'addresses',
            });
        },
        openClinics() {
            this.$root.$router.push({
                name: 'clinics',
            });
        },
        openCases() {
            this.$root.$router.push({
                name: 'cases',
            });
        },
    },
});
